import React from 'react';
import image3 from "../../images/article (3).png"
import image5 from "../../images/boyTree.jpg"
import sideImage1 from "../../images/datawithSS.png"
import sideImage2 from "../../images/Rectangle 333 (1).png"
// import sideImage3 from "../../images/Article (6).png"
import sideImage4 from "../../images/Article (4).png"
import { Link } from 'react-router-dom';
const SIDEBAR_ARTICLES = [
  {
    id: 'sidebar-1',
    type: 'Events',
    typeColor: 'text-[#7BC216]',
    tag: 'Clean Transport',
    title: 'Netzence set to unveil clean mobility hailing App in June 2026',
    excerpt: 'At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems',
    readTime: '5 mins read',
    date: '2/3/2026',
    imageUrl: sideImage1,
    heightClass: 'h-[497px]',
    link:"/blogPost"
  },
  {
    id: 'sidebar-2',
    type: 'ADVERT',
    typeColor: 'text-[#099137]',
    tag: 'Climate Change',
    title: 'Climate Reports Belong to the Public - Not the Shadows',
    excerpt: 'Average citizen that I am, I’d heard about climate change and wanted some accurate information about it...',
    readTime: '4 mins read',
    date: '21/2/2026',
    imageUrl: sideImage2,
    heightClass: 'h-[497px]',
    link:"/articlePost2"
  },
  {
    id: 'sidebar-2',
    type: 'ARTICLE',
    typeColor: 'text-[#099137]',
    tag: 'Lifestyle ',
    title: 'The Seven Stages of Climate Grief',
    excerpt: 'Exploring how investing in carbon offset initiatives can pave the way for a sustainable future.',
    readTime: '12 mins read',
    date: '23/1/2026',
    imageUrl: image5,
    heightClass: 'h-[497px]',
    link:"/articlePost8"
  },
  {
    id: 'sidebar-2',
    type: 'ARTICLE',
    typeColor: 'text-[#099137]',
    tag: 'Climate Change',
    title: 'Climate Reports Belong to the Public - Not the Shadows',
    excerpt: 'In an era marked by climate urgency, social inequity, and an ever-evolving investment landscape, the practice of',
    readTime: '12 mins read',
    date: '10/12/2026',
    imageUrl: sideImage4,
    heightClass: 'h-[497px]',
    link:"/articlePost4"

  }
];

export const ArticlePost3 = () => {
  return (
    <div className="w-full min-h-screen bg-white py-12 px-4 md:px-8 lg:px-0 font-['SF_Pro_Display'] antialiased selection:bg-[#7BC216]/20">
      
      {/* Frame 2147228719: Main Layout Wrapper */}
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-start gap-[32px]">
        
        {/* Frame 2147228721: Left Column (Main Article Body) */}
        <main className="w-full lg:w-[758px] flex flex-col gap-[32px]">
          
          {/* Frame 2147228724: Featured Image Banner */}
          <div className="w-full h-[350px] sm:h-[450px] md:h-[612px] rounded-[12px] overflow-hidden shadow-sm bg-[#FAFAFA]">
            <img 
              loading="lazy"
              src={image3} 
              alt="Sustainable Favelas and Urban Development" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Frame 2147228717 & 2147228715: Content Canvas Area */}
          <article className="w-full lg:max-w-[755px] flex flex-col gap-[24px] text-[#3B3B3B] text-[18px] leading-[28px]">
            
            <p className="text-justify font-normal">
              In an era marked by climate urgency, social inequity, and an ever-evolving investment landscape, the practice of allocating capital responsibly has become both a financial necessity and a societal imperative. Few individuals exemplify this intersection more fully than David Blood, a founding Partner of Generation Investment Management, alongside former U.S. Vice President Al Gore and a group of like-minded partners. As one of the first pure-play global sustainable investing firms, under David Blood’s leadership, Generation has been a pioneer in advancing sustainable investing, anchored in a mission-driven culture and a long-term view.
            </p>

            <p className="font-normal">
              Previously, David spent 18 years at Goldman Sachs, including serving as CEO of Goldman Sachs Asset Management. David received a BA from Hamilton College and an MBA from Harvard Business School. He is chair of Just Climate, Social Finance UK and the World Resources Institute, on the board of On the Edge Conservation and on the advisory board of the Harvard Salata Institute for Climate and Sustainability.
            </p>

            <hr className="border-gray-100 my-4" />

            {/* Q&A Structure */}
            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Emily Chien:</span>
              <p className="text-justify font-normal">
                Generation Investment Management is widely recognized as a pioneer in sustainable investing since its founding 21 years ago. Can you share Generation’s origin story — and what motivated you to embark on this journey?
              </p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">David Blood:</span>
              <p className="text-justify font-normal">
                Let me start by sharing some context around how I came to care about sustainability in the first place. I spent part of my childhood in Brazil, and from our kitchen window I could see a favela — which translates as a slum — where a boy my own age lived in conditions drastically different from mine. That stark contrast made a deep impression on me, so my interest in social justice and poverty goes back to those very early years.
              </p>
            </div>

            <p className="text-justify font-normal">
              My finance career began by chance when I took a commercial banking job after college at Bankers Trust simply because I needed a job. Later, in between my first and second year at Harvard Business School (HBS), I interned at an investment bank and had a truly terrible summer experience. There was no sense of clients, of teamwork, or of any purpose. That experience, however disheartening, taught me how important culture is in any business setting. After finishing HBS, I joined Goldman Sachs because its culture of teamwork, meritocracy, and client-first principles resonated with me. Over the years, I observed that every one of the many investment bank failures could be traced back to failings in culture, leadership, governance, or risk. That realization formed the bedrock of my personal philosophy on how to build and run businesses — and the realization that non-financial factors are relevant to the success of a business.
            </p>

            <p className="text-justify font-normal">
              Just like you, Emily, I like building businesses, which I had the chance to do at Goldman. When I retired in 2003, I realized that I wanted to be doing something different — to help build a sustainable investing firm. In fact, the term “ESG” didn’t even exist then.
            </p>

            <p className="text-justify font-normal">
              Our seven founding partners in 2004, including Al Gore, Mark Ferguson, Miguel Nogales, Colin le Duc, and other colleagues — recognized that climate change and sustainable human development are intertwined — two sides of the same coin. We believed that bringing together sustainability knowledge with the finance discipline could yield differentiated insights and potentially better risk-adjusted investment returns. Today, we have approximately $40 billion in assets under management or supervision, which includes Just Climate, an investment business targeting solutions that aim to radically reduce or remove emissions while generating attractive risk-adjusted financial returns. This business is particularly focused on industrial decarbonization, restoring nature, biodiversity, and land-use transformation solutions.
            </p>

            <p className="text-justify font-normal">
              We’re a Certified B Corp. and mission driven. However, this does not mean not-for-profit. Our mission aims to: 1) deliver long-term, attractive, risk-adjusted investment returns and positive impact; and 2) help establish sustainable investing as mainstream — ultimately as a means to help drive change in our economies and societies.
            </p>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="font-bold text-justify">What have you learned since founding Generation?</p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">
                If I’ve learned anything over the years, it’s about culture and mission. And if anything has surprised me, it’s that culture and mission matter more than I thought. Our firm’s origin story has set the tone for the journey we’ve been on. It’s as fresh today — in fact, probably more urgent today — than it was 21 years ago when we started. We believe that climate change, biodiversity loss, and economic inequality represent financial issues, and that fulfilling a fiduciary duty as investors requires taking these elements into consideration in capital allocation.
              </p>
            </div>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="font-bold text-justify">Looking back at Generation’s early days, what are you most proud of? And with hindsight, is there anything you’d approach differently?</p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">
                We have a deep culture and tradition as a learning organization, and we consistently challenge ourselves to do things better and differently. For instance, each year we take a step back in a “Hits and Misses” exercise. We reflect on what we have learned, what mistakes we have made, and what we have done well.
              </p>
            </div>

            <p className="text-justify font-normal">
              I don’t think we’re satisfied or proud that sustainable investing has become mainstream — as it is absolutely not sufficient to drive the transformational change we need — and how we think about capital allocation going forward. We’re under no illusion that we’re even close to achieving what I think we collectively want to achieve in society.
            </p>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="font-bold text-justify">What does the future of sustainable investing look like — and what conditions are necessary for its growth and impact?</p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">
                We are convinced that we’re in the early or middle stages of a critical economic transition — from a resource-intensive, often short-term model to one that is more sustainable, equitable, and long-term. It’s fundamental to how business will be done, and risk will be priced going forward. It’s going to happen, and it is happening. We know that if we are unsustainable — if we ultimately run out of resources on a finite planet — things stop working, whether that’s the climate, people or nature.
              </p>
            </div>

            <p className="text-justify font-normal">
              On the other hand, we’re facing significant sustainability headwinds, and there are plenty of challenges, if you will. Yet, sustainability is not going away. What we need to do is create the enabling conditions for sustainable solutions to happen.
            </p>

            <p className="text-justify font-normal">
              Generation believes there are three important steps needed as a sustainable investing community, and we certainly hope to be among those leading this effort:
            </p>

            <p className="font-bold text-justify">
              Make the business case for sustainable investing more clearly, rigorously, and robustly, and say why it is part of fiduciary duty. Streamline and improve data and reporting frameworks. Catalyze capital to the Global South.
            </p>

            <p className="text-justify font-normal">
              Broadening investment management to include impact is fundamentally about internalizing externalities — impacts on nature, the climate, and our communities. Today, with poor incentives and a fragmented regulatory environment, we don’t yet bring in non-financial elements into our pricing and capital allocations. So, we are incorrectly misallocating capital as a society. There are numerous rules, regulations, and reporting regimes around the globe for tracking sustainability progress. We think that the IFRS (International Financial Reporting Standards) and its International Sustainability Standards Board (ISSB) — a not-for-profit organization that develops global sustainability standards — can play a key role in simplifying reporting requirements.
            </p>

            <p className="text-justify font-normal">
              We are optimistic that while, yes, investors are stuck on furthering sustainability progress, and yes, headwinds exist, we have a collective imperative that is both significant and important. For instance, the clean energy transition is transformational, and the investing opportunities are really interesting. We’re going to do a lot of work to try to help bring the investment community together on these three areas over 2025 and 2026.
            </p>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="font-bold text-justify">Generation emphasizes long-term value, yet many companies and investors face pressure for short-term results. How should we think about time horizon and risk-reward when factoring in climate and impact — and how does Generation define 'long-term'?</p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">
                That’s a really important question, since time horizon is at the heart of the challenge. At Generation, we define long-term similarly to Warren Buffett: five, 10, 15 years, or longer. That allows us to think in terms of compounding returns over the long term, and that is a superior way to run a business and manage capital. Trading is a different, much shorter time horizon.
              </p>
            </div>

            <p className="text-justify font-normal">
              One of the reasons we established Generation is that we recognized the mismatch between investors’ confusion about the definition of long-term vs. following next quarter’s earnings. If a capital allocator wants to allocate to a trading strategy, that’s one thing. But we know that long-term investing is a best practice, and we are focused on delivering attractive, risk-adjusted results over time — because our clients are fiduciaries with a longer-term horizon. A second premise we have is that sustainability over the long term drives the success of economies and societies.
            </p>

            <p className="text-justify font-normal">
              So, the argument is: if you’re a fiduciary and in 15 years you’ve delivered a 3º C warmer world with a degraded environment, biodiversity loss, and significant inequality, then you simply have not fulfilled your fiduciary duty. Eventually, those scenarios drag down economic growth, asset values, and quality of life. The key is re-aligning incentives and performance metrics to reflect a long-term mandate.
            </p>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="font-bold text-justify">What is the role of an investor’s fiduciary duty in the context of sustainability? This question is at the heart of A Legal Framework for Impact, commissioned by the Generation Foundation alongside the PRI (Principles for Responsible Investment) and the UNEP FI (United Nations Environment Programme Finance Initiative). What key insights emerged from the research?</p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">
                Without a doubt, I think it’s our most important piece of work that the Generation Foundation has pursued, and it will be one of our priorities as we continue to advocate for sustainability over the next several years.
              </p>
            </div>

            <p className="text-justify font-normal">
              The issue — which relates to making the business case for sustainable investing — is the significant confusion around whether understanding sustainability is part of an investor’s fiduciary duty. When we established Generation, one of the first questions we needed to answer was if it is possible/permitted for a fiduciary to take a broader range of facts and issues to deploy capital. And the answer is yes, as put forth in the October 2005 UNEP Finance Initiative’s report, A legal framework for the integration of environmental, social and governance issues in institutional investment.
            </p>

            <p className="text-justify font-normal">
              For instance, if you’re a pension fund trustee or other institutional investor in Florida, and you don’t consider climate change risk — particularly in a real estate portfolio, given Florida’s vulnerability to rising sea levels and catastrophic hurricanes — there’s a strong argument that is going to impact your ability to deliver risk-adjusted client returns and you’re violating your fiduciary responsibility. The law is increasingly on the side of those who say we need to integrate sustainability, not put our heads in the sand.
            </p>

            <p className="text-justify font-normal">
              In addition, the Partners of Generation have contributed significant funding to Climate TRACE, a non-profit coalition of universities, AI technology companies, and NGOs that is developing the world’s first comprehensive emissions tracking system for GHG and non-GHG air pollutants using direct, independent observation of large emitters. These emissions affect millions of people’s health around the globe.
            </p>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="font-bold text-justify">Looking ahead to COP 30 (The United Nations Climate Change Conference of the Parties) in Brazil — a country central to your journey — where do you see key issues heading, and what gives you hope?</p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">
                I think the Brazilians will take a step forward, notwithstanding the challenges in the U.S. In Brazil, we have an administration under President Lula that’s vocal about protecting the Amazon and addressing social needs together. That aligns well with the interconnected view of nature, climate, and poverty.
              </p>
            </div>

            <p className="text-justify font-normal">
              So, we’re optimistic that the host will be aligned with a great outcome. Now, it will be a challenge of course — since the UN climate process itself has challenges — with slow, consensus-based negotiations, and major emitters don’t always pull in the same direction. But there’s no denying that real-world climate impacts are becoming too large to ignore. They are happening right now — and only accelerating. These sad events exert pressure on governments and business leaders alike to act.
            </p>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="font-bold text-justify">Closing remarks?</p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">
                The transition is inevitable — but whether the world makes a just transition in time to avoid horrific consequences for humanity is not. This challenge requires people to rise above the political parapets to say and do what’s right. We believe in deploying capital toward decarbonized energy, sustainable infrastructure, and thriving natural systems that can create jobs, foster innovation, and stabilize societies. There will be setbacks, and the path will be challenging, for sure. But if we focus on the business case, the fundamentals of science and finance, and what we can do now, it will happen more quickly than people think.
              </p>
            </div>

            <hr className="border-gray-100 my-4" />

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Chien:</span>
              <p className="text-justify font-medium text-gray-700">
                David, your reflections offer both clarity and inspiration for the future of sustainable investing. Thank you for your leadership and for sharing your vision and insights with us today.
              </p>
            </div>

            <div className="flex flex-col gap-[8px]">
              <span className="font-bold text-black text-[19px]">Blood:</span>
              <p className="font-bold text-justify">Emily, it’s been great speaking with you. Thank you.</p>
            </div>

            {/* Frame 2147228718: Article Source Block */}
            <div className="mt-8 pt-4 border-t border-[#E4E7EC] flex flex-col gap-[8px]">
              <span className="text-[20px] font-bold text-[#3B3B3B]">Source</span>
              <a 
                href="https://www.sir.advancedleadership.harvard.edu/articles/future-of-sustainable-investing-david-blood-generation-investment-management"
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[16px] text-gray-500 break-all hover:text-[#7BC216] transition-colors font-normal"
              >
                https://www.sir.advancedleadership.harvard.edu/articles/future-of-sustainable-investing-david-blood-generation-investment-management
              </a>
            </div>

          </article>
        </main>

        {/* Frame 2147228722: Right Column (Sidebar Container Area) */}
        <aside className="w-full lg:w-[410px] flex flex-col gap-[32px] pt-8 lg:pt-0">
          
          <h2 className="text-[32px] font-bold text-[#141414] tracking-tight leading-[38px]">
            More Articles
          </h2>

          <div className="flex flex-col gap-[32px] w-full">
            {SIDEBAR_ARTICLES.map((article) => (
              <Link to={article.link} 
                key={article.id}
                className={`w-full bg-white border border-[#E4E7EC] rounded-[12px] overflow-hidden flex flex-col group hover:shadow-md transition-shadow duration-300 ${article.heightClass}`}
              >
                {/* Media Node Layout block area */}
                <div className="w-full h-[289px] bg-slate-50 overflow-hidden relative">
                  <img 
                  loading='lazy'
                    src={article.imageUrl} 
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-102"
                  />
                </div>

                {/* Data Description Meta Text Frame Wrapper block */}
                <div className="p-4 flex flex-col justify-between flex-grow gap-4">
                  
                  <div className="flex flex-col gap-[11px]">
                    
                    {/* Badge Container Header Row */}
                    <div className="flex items-center gap-[8px] h-[20px]">
                      <span className={`text-[16px] font-medium tracking-wider uppercase font-sans ${article.typeColor}`}>
                        {article.type}
                      </span>
                      <span className="w-[6px] h-[6px] rounded-full bg-[#8D8484]" />
                      <div className="bg-[#3E3838] text-white text-[12px] font-normal px-[6px] py-[3px] rounded-[2px] tracking-wide whitespace-nowrap leading-none">
                        {article.tag}
                      </div>
                    </div>

                    {/* Header and Snippet Paragraph Area Block */}
                    <div className="flex flex-col gap-[8px]">
                      <h3 className="text-[20px] font-medium text-[#3B3B3B] leading-[24px] tracking-tight line-clamp-2 transition-colors group-hover:text-black">
                        {article.title}
                      </h3>
                      <p className="text-[14px] text-[#898989] leading-[17px] line-clamp-2 font-normal">
                        {article.excerpt}
                      </p>
                    </div>

                  </div>

                  {/* Operational Timeline Footer Row */}
                  <div className="flex justify-between items-center -pt-3 pb-5 border-gray-100  text-[14px] text-[#3B3B3B] font-medium lowercase">
                    <span>{article.readTime}</span>
                    <span className="text-[12px] text-[#B1B1B1] font-normal normal-case">{article.date}</span>
                  </div>

                </div>

              </Link>
            ))}
          </div>

        </aside>

      </div>
    </div>
  );
}
export default ArticlePost3